import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule,DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { SessionService } from '../../Util/Session/session.service';
import { HolidayService } from '../../Model/Holiday/holiday.service';
import { CommonService } from '../../Model/Common/common.service';


@Component({
  selector: 'app-holiday-list-on-id',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule,NgbDatepicker,DataTablesModule],
  templateUrl: './holiday-list-on-id.component.html',
  styleUrl: './holiday-list-on-id.component.scss'
})
export class HolidayListOnIDComponent {
  dtTrigger: Subject<any> = new Subject<any>();
  public User: any = null;
  isDisabled: boolean = false;
  HolidayListsOnID : any[] = [];
  dtoptions: DataTables.Settings = {};
  constructor(
    private session: SessionService,
    private holiday : HolidayService,
    protected common: CommonService,
  ){
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.getHolidaylistonID(); 
  } 
  
  getHolidaylistonID(){
    this.User = this.session.GetUserDetails();
    this.isDisabled = true;
    const holiday = {
      EmpmasterId: this.User.UserId
    };
    this.holiday.GetHolidayDetailsOnID(holiday).subscribe(
      data => {
        this.HolidayListsOnID = Object.values( data.Table);
      },
      error => {
        console.error('Error:', error);
      }
    );
  }
}
